<span class="role-chip" data-testid="role-chip" [style.--chip-accent]="accent()" [title]="label()">{{ label() }}</span>
